import HomePage from "pages/HomePage";
import React from "react";

const HomeRoute = () => <HomePage />;

export default HomeRoute;
